const Award = () => import(/* webpackChunkName: "manager" */ './Index');
const Personal = () => import(/* webpackChunkName: "personal" */ './Personal');

import Rept from '@/components/awar/rept/router'

export default {
    routes: [
        {
            path: '/awar/index',
            name: 'awar_index',
            component: Award
        },
        {
            path: '/awar/personal',
            name: 'awar_personal',
            component: Personal
        },
        ...Rept.routes
    ]
}
